import { LABELS } from "~/resources/Labels";
import { TemplateResponse } from "~/models/Commons ";
import { SIMPLDialog } from "../.././components/commons/dialog/SimplDialog";

interface DetailProps {
  item?: TemplateResponse;
  onClose: () => void;
  title: string;
}

const valueClass =
  "py-3 px-2 bg-[#efefef] rounded-md break-words max-w-[600px]";
const labelClass = "font-semibold max-w-[300px]";
export const DetailsVmTemplate = ({ title, item, onClose }: DetailProps) => {
  return (
    <SIMPLDialog onCloseModal={onClose} title={title}>
      <div className="w-auto pb-5 flex flex-col">
        <div className="flex flex-row mt-3">
          <div className="flex-1">
            <div className={labelClass}>{LABELS.Name}</div>
            <div className={valueClass}>{item?.name}</div>
          </div>
        </div>
        <div className="flex flex-row mt-3">
          <div className="flex-1">
            <div className={labelClass}>{LABELS.Description}</div>
            <div className={valueClass}>{item?.description}</div>
          </div>
        </div>
        <div className="flex-1">
          <div className={labelClass}>{LABELS.CloudEnviroment}</div>
          <div className={valueClass}>
            {item?.cloudEnvironment.environmentName}
          </div>
        </div>
        <div className="flex-1">
          <div className={labelClass}>{LABELS.CloudProviderWithSpace}</div>
          <div className={valueClass}>
            {item?.cloudEnvironment.cloudProvider.cloudProviderName}
          </div>
        </div>
        <div className="flex flex-row mt-3">
          <div className="flex-1">
            <div className={labelClass}>{LABELS.ProvisioningTemplate}</div>
            <div className={valueClass}>
              {item?.cloudProvisionerTemplate.fileName}
            </div>
          </div>
        </div>
        {item?.cloudProvisionerTemplate.azureVmSize && (
          <div className="flex flex-row mt-3">
            <div className="flex-1 truncate">
              <div className={labelClass}>{"Azure VM Size"}</div>
              <div className={valueClass}>
                {item?.cloudProvisionerTemplate.azureVmSize}
              </div>
            </div>
          </div>
        )}
        {item?.cloudProvisionerTemplate.azureLocation && (
          <div className="flex flex-row mt-3">
            <div className="flex-1 truncate">
              <div className={labelClass}>{"Azure Location"}</div>
              <div className={valueClass}>
                {item?.cloudProvisionerTemplate.azureLocation}
              </div>
            </div>
          </div>
        )}
        {item?.cloudProvisionerTemplate.azureResourceGroup && (
          <div className="flex flex-row mt-3">
            <div className="flex-1 truncate">
              <div className={labelClass}>{"Azure Resource Group"}</div>
              <div className={valueClass}>
                {item?.cloudProvisionerTemplate.azureResourceGroup}
              </div>
            </div>
          </div>
        )}
        {item?.os && (
          <div className="flex flex-row mt-3">
            <div className="flex-1">
              <div className={labelClass}>{LABELS.Os}</div>
              <div className={valueClass}>{item?.os}</div>
            </div>
          </div>
        )}

        {item?.cpuCore && (
          <div className="flex flex-row mt-3">
            <div className="flex-1 truncate">
              <div className={labelClass}>{LABELS.CpuCore}</div>
              <div className={valueClass}>{item?.cpuCore}</div>
            </div>
          </div>
        )}
        {item?.storage && (
          <div className="flex flex-row mt-3">
            <div className="flex-1 truncate">
              <div className={labelClass}>{LABELS.DiskSize}</div>
              <div className={valueClass}>{item?.storage}</div>
            </div>
          </div>
        )}
        {item?.ram && (
          <div className="flex flex-row mt-3">
            <div className="flex-1 truncate">
              <div className={labelClass}>{LABELS.Ram}</div>
              <div className={valueClass}>{item?.ram}</div>
            </div>
          </div>
        )}
      </div>
    </SIMPLDialog>
  );
};
